import { useGetPath } from '@hooks/interview/useGetPath';
import { useCondition } from '@hooks/utils/useCondition';
import { type PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

const InterviewerAuthenticatedLayout = ({ children }: PropsWithChildren) => {
  const { rootPath } = useGetPath();
  const { isUserLoggedIn, hasInterviewerMeetingCondition } = useCondition();

  if (!isUserLoggedIn && hasInterviewerMeetingCondition)
    return <Navigate to={rootPath.SETTING} replace />;

  if (!isUserLoggedIn && !hasInterviewerMeetingCondition)
    return <Navigate to={rootPath.HOME} replace />;

  return <>{children}</>;
};

export default InterviewerAuthenticatedLayout;
